import { Navigate } from 'react-router-dom'
import { AddressSchedulerRedirect } from '../../components/AddressSchedulerRedirect'
import { READ_LOCATION_CHANGE_SCOPE, VALIDATE_ADDRESS_SCOPE, WRITE_LOCATION_CHANGE_SCOPE } from '../../constants'
import { AppRoute } from '../../auth/routeAuth'
import { AddressConfirmationPage } from './AddressConfirmationPage/AddressConfirmationPage'
import { AddressSchedulerFormPage } from './AddressSchedulerFormPage/AddressSchedulerFormPage'
import { DatePickerPage } from './DatePickerPage/DatePickerPage'
import { OverviewPage } from './OverviewPage/OverviewPage'
import { TimeZonePage } from './TimeZone/TimeZonePage'
import { ValidationResultsPage } from './ValidationResultsPage/ValidationResultsPage'
import { addressValidationPaths } from './addressValidationPaths'

/**
 * Note: Top-level components need to render a Page Component
 */
export const addressSchedulerRoutes: AppRoute[] = [
  { index: true, element: <Navigate to="overview" replace /> },
  {
    path: addressValidationPaths.overview,
    element: <OverviewPage />,
    auth: { scopes: [READ_LOCATION_CHANGE_SCOPE], mode: 'all' }
  },

  /*
   * NOTE: This route is singled out of the next route's children because we need to bypass the checks in
   * AddressSchedulerRedirect when the user is not updating an existing location change.
   */
  {
    path: addressValidationPaths.addressForm,
    element: <AddressSchedulerFormPage />,
    auth: { scopes: [VALIDATE_ADDRESS_SCOPE], mode: 'all' }
  },

  {
    path: ':locationChangeId?',
    element: <AddressSchedulerRedirect />,
    auth: { scopes: [VALIDATE_ADDRESS_SCOPE, WRITE_LOCATION_CHANGE_SCOPE], mode: 'all' },
    children: [
      { path: addressValidationPaths.addressForm, element: <AddressSchedulerFormPage /> },
      { path: addressValidationPaths.validationResults, element: <ValidationResultsPage /> },
      { path: addressValidationPaths.confirmation, element: <AddressConfirmationPage /> },
      { path: addressValidationPaths.timeZone, element: <TimeZonePage /> },
      { path: addressValidationPaths.datePicker, element: <DatePickerPage /> }
    ]
  }
]
